import { Routes } from '@angular/router';
import { AppPath } from '../utils/constants/paths';

export const secureRoutes: Routes = [
  {
    path: AppPath.partner,
    loadChildren: () => import('../pages').then((C) => C.PartnerModule),
    data: { title: 'DASHBOARD' },
  },
  {
    path: AppPath.dashboard,
    loadChildren: () => import('../pages').then((C) => C.DashboardModule),
    data: { title: 'DASHBOARD' },
  },
  {
    path: AppPath.company,
    loadChildren: () => import('../pages').then((C) => C.CompanyModule),
    data: { title: 'Company' },
  },
  {
    path: AppPath.invoices,
    loadChildren: () => import('../pages').then((C) => C.ManageInvoiceModule),
    data: { title: 'Company' },
  },
  {
    path: AppPath.manageAdmin,
    loadChildren: () => import('../pages').then((C) => C.ManageAdminModule),
    data: { title: 'ADMIN' },
  },
  {
    path: AppPath.manageAgent,
    loadChildren: () => import('../pages').then((C) => C.ManageAgentModule),
    data: { title: 'MANAGE_AGENT' },
  },
  {
    path: AppPath.manageAgentSub,
    loadChildren: () => import('../pages').then((C) => C.ManageAgentSubModule),
    data: { title: 'SUB_USER' },
  },
  {
    path: AppPath.manageMember,
    loadChildren: () => import('../pages').then((C) => C.ManageMemberModule),
    data: { title: 'MANAGE_MENBER' },
  },
  {
    path: AppPath.credit,
    loadChildren: () => import('../pages').then((C) => C.CreditModule),
    data: { title: 'CREDIT' },
  },
  {
    path: AppPath.user,
    loadChildren: () => import('../pages').then((C) => C.UserModule),
    data: { title: 'USER' },
  },
  {
    path: AppPath.games,
    loadChildren: () => import('../pages').then((C) => C.GamesModule),
    data: { title: 'GAMES' },
  },
  {
    path: AppPath.help,
    loadChildren: () => import('../pages').then((C) => C.HelpModule),
    data: { title: 'HELP' },
  },
  {
    path: AppPath.settings,
    loadChildren: () => import('../pages').then((C) => C.SettingsModule),
    data: { title: 'WORK_DEPOSIT' },
  },

  {
    path: AppPath.transaction,
    loadChildren: () => import('../pages').then((C) => C.TransactionModule),
    data: { title: 'TRANSACTION' },
  },
  {
    path: AppPath.profile,
    loadChildren: () => import('../pages').then((C) => C.ProfileModule),
    data: { title: 'PROFILE' },
  },
  {
    path: AppPath.reports,
    loadChildren: () => import('../pages').then((C) => C.ReportsModule),
    data: { title: 'REPORTS' },
  },
  {
    path: AppPath.Jobs,
    loadChildren: () => import('../pages').then((C) => C.BackgroundJobsModule),
    data: { title: 'BACKGROUP_JOBS' },
  },
  {
    path: AppPath.logs,
    loadChildren: () => import('../pages').then((C) => C.LogsModule),
    data: { title: 'Logs' },
  },
  {
    path: AppPath.manageSMS,
    loadChildren: () => import('../pages').then((C) => C.ManageSmsModule),
    data: { title: 'SMS' },
  },
  {
    path: AppPath.helpUser,
    loadChildren: () => import('../pages').then((C) => C.HelpUserModule),
    data: { title: 'HELP USER' },
  },
  {
    path: AppPath.announce,
    loadChildren: () => import('../pages').then((C) => C.AnnounceModule),
    data: { title: 'ANNOUNCE' },
  },
  {
    path: AppPath.supportAdmin,
    loadChildren: () => import('../pages').then((C) => C.SupportAdminModule),
    data: { title: 'SUPPORT_ADMIN' },
  },
  {
    path: AppPath.settingAgentFE,
    loadChildren: () => import('../pages').then((C) => C.SettingAgentFeModule),
    data: { title: 'SUPPORT_ADMIN' },
  },
  {
    path: AppPath.memberOutstanding,
    loadChildren: () => import('../pages').then((C) => C.MemberOutstandingModule),
    data: { title: 'MEMBER_OUTSTANDING' },
  },
  {
    path: AppPath.Developer,
    loadChildren: () => import('../pages').then((C) => C.DeveloperModule),
    data: { title: 'DEVELOPER' },
  },
  {
    path: AppPath.stockSports,
    loadChildren: () => import('../pages').then((C) => C.StockSportsModule),
    data: { title: 'Stock Sports' },
  },
  {
    path: AppPath.stockESports,
    loadChildren: () => import('../pages').then((C) => C.StockEsportsModule),
    data: { title: 'Stock E-Sports' },
  },
  {
    path: AppPath.stockLotto,
    loadChildren: () => import('../pages').then((C) => C.StockLottoModule),
    data: { title: 'Stock Lotto' },
  },
  {
    path: AppPath.inMemory,
    loadChildren: () => import('../pages').then((C) => C.InMemoryModule),
    data: { title: 'In Memory' },
  },
];
